import React from 'react'
import { RouteComponentProps } from 'react-router'

import PageHeader from 'App/components/PageHeader'
import { useFeatureEnabled } from 'core/feature/hooks'
import { CustomMessagesClient } from './CustomMessagesClient'
import { CustomMessagesServerSide } from './CustomMessagesServerSide'

export const CustomMessages = (props: RouteComponentProps) => {
  const isCustomMessagesServerSideListEnabled = useFeatureEnabled('CustomMessagesServerSideList')

  return (
    <PageHeader title="Custom Messages" subTitle="Compose and review messages sent to members of your organization">
      {isCustomMessagesServerSideListEnabled ? (
        <CustomMessagesServerSide {...props} />
      ) : (
        <CustomMessagesClient {...props} />
      )}
    </PageHeader>
  )
}

export default CustomMessages
